import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";

import { User } from "../models/user.model";
import { UserType } from "../models/userType.models";
import { SalesRep } from "../models/sales-rep.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, firstValueFrom, map } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";

const BASE_URL = `${BACKEND_URI}/api/user`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_URL = (id) => `${BASE_URL}/${id}`;
const SET_ENABLED_URL = (id) => `${BASE_URL}/${id}/enable-update`;
const CHANGE_PRIMARY_EMAIL_URL  = (id) => `${BASE_URL}/${id}/primary-email-update`;
const RESET_PASSWORD_URL        = (id) => `${BASE_URL}/${id}/gen-pass-reset`;

interface UserCreateResponse {
    user?: User;
    errors?: Array<String>
}

@Injectable({providedIn: 'root'})
export class UserService {
    constructor(private http: HttpClient, private loginService: LoginService){}
    async getAll(): Promise<User[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<User[]>(GET_ALL_URL)
            );
        }
    }
    async create(data: User): Promise<UserCreateResponse> {
        if(this.loginService.isloggedIn) {
            let status;
            try{
                return await firstValueFrom(
                    this.http.post<User>(INSERT_URL, data).pipe(
                        map(user=>({user}))
                    )
                );
            } catch(err) {
                if(err.status == 512) {
                    return {errors: ["Error sending password email"]};
                }
                return {errors: ["unknown error"]};
            }
        }
    }
    async update(id: string, data: User): Promise<User> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<User>(UPDATE_URL(id), data)
            );
        }
    }
    async setEnabled(id: string, enabled: boolean): Promise<User> {
        if(this.loginService.isloggedIn) {
            console.trace(`setEnabled(${enabled}): user is logged in`)
            return await firstValueFrom(
                this.http.patch<User>(SET_ENABLED_URL(id), {enabled})
            );
        }else {
            console.error(`setEnabled(${enabled}): not logged in`)
        }
    }
    async delete(id: string) {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_URL(id))
                );
            } catch(err) {}
        }
    }
    async changePrimaryEmail(id: string, newPrimaryEmail: string) {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.patch<User>(CHANGE_PRIMARY_EMAIL_URL(id), {newPrimaryEmail})
            );
        }
    }
    async resetPassword(id: string) {
        if(this.loginService.isloggedIn) {
            try{
                return await firstValueFrom(
                    this.http.patch(RESET_PASSWORD_URL(id), {})
                );
            } catch(err) {
                console.log('resetPassword()', err)
            }
        }
    }
}